import { render, staticRenderFns } from "./ReservierungVorbestellungArtikel.vue?vue&type=template&id=2e4ce5cb"
import script from "./ReservierungVorbestellungArtikel.vue?vue&type=script&lang=ts"
export * from "./ReservierungVorbestellungArtikel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports